import { ActionModalType } from 'components/ActionModal'
import { heapEvent } from '@equipmentshare/heaper'
import ExportCsvModal from './ExportCsvModal'
import ExportAdjustmentsCsvModal from './ExportAdjustmentsCsvModal'

export function getExportCsvModal(): ActionModalType {
	return {
		component: ExportCsvModal,
		label: 'Export CSV',
		onXClick: () => heapEvent( 'Inventory - Export CSV Modal - Click - X button', {} ),
	}
}

export function getExportAdjustmentsCsvModal(): ActionModalType {
	return {
		component: ExportAdjustmentsCsvModal,
		label: 'Export Inventory Adjustments CSV',
		onXClick: () => heapEvent( 'Inventory - Export Adjustment CSV Modal - Click - X button', {} ),
	}
}
